var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chackmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#F2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.66536 13.1868L5.94727 10.485C5.87131 10.4091 5.83333 10.3114 5.83333 10.1921C5.83333 10.0727 5.87131 9.97505 5.94727 9.8991L6.54948 9.31316C6.62543 9.22636 6.72038 9.18296 6.83431 9.18296C6.94824 9.18296 7.04861 9.22636 7.13541 9.31316L8.95833 11.1361L12.8646 7.22983C12.9514 7.14303 13.0517 7.09962 13.1657 7.09962C13.2796 7.09962 13.3745 7.14303 13.4505 7.22983L14.0527 7.81577C14.1287 7.89172 14.1666 7.98938 14.1666 8.10874C14.1666 8.22809 14.1287 8.32575 14.0527 8.4017L9.25129 13.1868C9.17534 13.2737 9.07768 13.3171 8.95833 13.3171C8.83897 13.3171 8.74131 13.2737 8.66536 13.1868Z",
    fill: "#9B6EE4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.c903f1be49bd3c59566e5d2e5aacd390.svg";
export { ForwardRef as ReactComponent };